import styled from '@emotion/styled'
import { ScopeUser } from '@pubstack/common/src/user'
import { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useEditUser } from '~/api/app/user.api'
import Button from '~/components/Button'
import { Flyout } from '~/components/Flyout'
import { Input } from '~/components/Input'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { Select } from '~/components/Select'
import { WithClassName } from '~/types/utils'
import { USER_ROLE_OPTIONS } from './SettingsMembersPage'

const EditMemberForm = styled.form`
  width: 450px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  & ${Button} {
    align-self: flex-start;
  }
`

const EditActionsWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 24px;
`
type SettingsMembersPageEditFlyoutProps = WithClassName & {
  member: ScopeUser
}
export const SettingsMembersPageEditFlyout: FC<SettingsMembersPageEditFlyoutProps> = ({ member }) => {
  const { mutateAsync: editUser } = useEditUser(member.email, {
    successToast: (
      <>
        <strong>{member.nickname}</strong>&#39;s information has been updated.
      </>
    ),
    errorToast: 'An error occurred while updating this user.',
  })
  const { close } = useGlobalFlyout()
  const {
    control,
    reset,
    handleSubmit,
    formState: { isDirty },
  } = useForm<ScopeUser>({
    defaultValues: member,
  })

  const saveChanges = async (member: ScopeUser) => {
    await editUser(member)
    close()
  }

  useEffect(() => {
    reset(member)
  }, [member])

  return (
    <Flyout.Content>
      <Flyout.Title>{member?.nickname}</Flyout.Title>
      <Flyout.Body>
        <EditMemberForm>
          <Input readOnly disabled control={control} name={'nickname'} label={'Name'} />
          <Input readOnly disabled control={control} name={'email'} label={'E-mail address'} />
          <Select control={control} name={'role'} options={USER_ROLE_OPTIONS} label={'Role'} />
        </EditMemberForm>
      </Flyout.Body>
      {isDirty && (
        <Flyout.Actions>
          <EditActionsWrapper>
            <Button onClick={() => reset(member)} iconName={'restore'} variant={'tertiary'} trackingLabel={'common-settings-members-edition-restore'}>
              Restore
            </Button>
            <Button onClick={handleSubmit(saveChanges)} trackingLabel={'common-settings-members-edition-save'}>
              Save changes
            </Button>
          </EditActionsWrapper>
        </Flyout.Actions>
      )}
    </Flyout.Content>
  )
}
